module.exports = __webpack_public_path__ + "img/house-keeping.82b3be31.svg";